exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar-default .navbar-nav>li>a {\r\n    cursor: pointer;\r\n}\r\n\r\n.navbar-nav {\r\n    margin: 0;\r\n}\r\n\r\n:host >>>.ui-messages {\r\n    padding-bottom: 2px;\r\n    padding-top: 2px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.css
// module id = 881
// module chunks = 8